import { SET_4DGAME_SUBTYPE ,SET_4DGAME_SUB_CHILDTYPE} from "./actionTypes";

export const set4dGameSubtype=response=>{
    return{
        type:SET_4DGAME_SUBTYPE,
        payload:response,
    }
}
export const set4dGameSubChildtype=response=>{
    return{
        type:SET_4DGAME_SUB_CHILDTYPE,
        payload:response,
    }
}